import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';

import get from '../../helpers/get';
import { itemType } from '../../propTypes/ourStoryItem';
import theme, {
  container,
} from '../../styles/theme';
import { getSliceContent, getSliceAnchorId } from '../../selectors';

import FullViewportContainer from '../FullViewportContainer';
import MaybeSwiper from '../Scrollers/MaybeSwiper';
import Tabs, { tabTheme } from './Tabs';
import Item from './Item';

class OurStory extends Component {
  state = {
    index: 0,
  };

  componentDidUpdate() {
    const { index } = this.state;
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  onTabClicked = i => {
    this.setState({
      index: i,
    });
  };

  onSlideChange = i => {
    this.setState({
      index: i,
    });
  };

  setSwiperRef = ref => {
    this.swiper = ref;
  };

  render() {
    const {
      classes, items, inverted, showNavBar, anchorId,
      navBarStyle,
    } = this.props;
    const { index } = this.state;

    return (
      <FullViewportContainer id={anchorId} className={cn(classes.container, { inverted })}>
        <div className={classes.wrapper}>
          <div className={classes.inner}>
            {showNavBar && items.length > 1 && (
              <Tabs
                tabs={items.map(item => ({
                  title: item.nav_title || item.title.text,
                }))}
                onTabClicked={this.onTabClicked}
                selectedIndex={index}
                tabTheme={inverted ? tabTheme.dark : tabTheme.light}
                navBarStyle={navBarStyle}
              />
            )}
            <MaybeSwiper
              className={classes.items}
              slideClassName={classes.slide}
              longSwipesRatio={0.25}
              prevNextButtons
              swiperRef={this.setSwiperRef}
              onSlideChange={this.onSlideChange}
              autoHeight
              spaceBetween={40}
            >
              {items.map((item, i) => (
                <Item
                  key={item.title.text}
                  item={item}
                  selected={index === i}
                  className={classes.slide}
                />
              ))}
            </MaybeSwiper>
          </div>
        </div>
      </FullViewportContainer>
    );
  }
}

OurStory.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  items: PropTypes.arrayOf(itemType).isRequired,
  inverted: PropTypes.bool.isRequired,
  showNavBar: PropTypes.bool,
  anchorId: PropTypes.string,
  navBarStyle: PropTypes.string,
};

OurStory.defaultProps = {
  showNavBar: true,
  anchorId: undefined,
  navBarStyle: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  items: get(getSliceContent(state, sliceId), ['items']) || [],
  inverted: get(getSliceContent(state, sliceId), ['style']) === 'inverted',
  showNavBar: get(getSliceContent(state, sliceId), ['nav_bar_visible']) === 'yes',
  navBarStyle: get(getSliceContent(state, sliceId), ['nav_bar_style']),
  anchorId: getSliceAnchorId(state, sliceId),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    container: {
      color: theme.colors.text,
      '&.inverted': {
        backgroundColor: theme.colors.brandBlack,
        color: theme.colors.white,
        padding: [theme.spacing.vertical.md, 0, 1],
        '& polygon': {
          fill: 'white',
          stroke: 'white',
        },
        // Temporary style for disabled chevron
        '& button.disabledChevron': {
          opacity: 0.5,
        },
      },
      // focus-visible isn't supported on Safari
      '& *:focus': {
        outline: 'revert',
      },
      '& *:focus-visible': {
        outline: 'revert',
        // for future, when Safari supports focus-visible (has 5px by default)
        outlineWidth: 1,
      },
    },
    wrapper: {
      marginBottom: theme.spacing.vertical.md,
    },
    inner: {
      ...container,
      '& > div:last-of-type': {
        '& > div': {
          paddingBottom: 50,
        },
        '& > button': {
          position: 'absolute',
          '&:first-child': {
            bottom: 0,
            paddingLeft: 0,
            right: 40,
          },
          '&:last-of-type': {
            bottom: 0,
            right: 0,
            paddingRight: 0,
          },
        },
      },
    },
    items: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    // this is needed to mark the slides for swiper
    slide: {
    },
  }),
)(OurStory);
